import rolesService from '../../services/rolesService'

class RolesController {
  fetchRoles = rolesService.fetchRoles
}

export default new RolesController()
 


// WEBPACK FOOTER //
// ../src/controllers/rolesController/rolesController.js